import { Page, View, Text, StyleSheet, Font, Image } from '@react-pdf/renderer';
import dayjs from 'dayjs';

import RobotoRegular from '@/assets/fonts/Roboto-Regular.ttf';
import RobotoBold from '@/assets/fonts/Roboto-Bold.ttf';
import JannaBold from '@/assets/fonts/Janna/Janna LT Bold.ttf';

import ReportCoverBackground from './ReportCoverBackground';
import RasmalReportFooterLogo from './RasmalReportFooterLogo';
import { useTranslation } from 'react-i18next';

Font.register({
  family: 'Roboto',
  fonts: [
    { src: RobotoRegular, fontStyle: 'normal', fontWeight: 'normal' },
    { src: RobotoBold, fontStyle: 'normal', fontWeight: 'bold' },
  ],
});

Font.register({
  family: 'Janna',
  fonts: [{ src: JannaBold, fontStyle: 'normal', fontWeight: 'normal' }],
});

const currentDate = dayjs(new Date()).format('DD/MM/YYYY');

const styles = StyleSheet.create({
  page: {
    position: 'relative',
    backgroundColor: '#fff',
    fontFamily: 'Roboto',
    padding: 0,
    margin: 0,
  },

  coverContent: {
    position: 'absolute',
    width: 200,
    left: 81,
    top: 150,
  },

  logo: {
    position: 'absolute',
    width: 100,
    right: 15,
    top: 50,
  },

  reportName: {
    fontWeight: 'bold',
    fontSize: 38,
    width: 290,
    color: '#391085',
    fontFamily: 'Janna',
  },

  reportSubName: {
    fontWeight: 'bold',
    fontSize: 12,
    width: 290,
    color: '#391085',
    fontFamily: 'Janna',
  },

  divider: {
    marginVertical: 8,
    width: 93,
    height: 6,
    backgroundColor: '#D81059',
  },

  reportDate: {
    fontSize: 10,
    color: '#554688',
  },

  footer: {
    backgroundColor: '#2A186A',
    paddingHorizontal: 20,
    paddingVertical: 4,
    height: 36,
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    margin: 0,
    fontFamily: 'Janna',
  },

  poweredBySection: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 4,
    fontFamily: 'Janna',
  },

  poweredByText: {
    fontSize: 10,
    color: '#fff',
    fontFamily: 'Janna',
  },

  website: {
    fontSize: 12,
    color: '#fff',
  },
});

const ReportCoverPage = ({
  reportNameAddtion,
  reportName,
  companyLogo,
}: {
  reportNameAddtion?: string;
  reportName: string;
  companyLogo?: string;
}) => {
  const { t, i18n } = useTranslation('reports', { keyPrefix: 'common' });

  return (
    <Page size="A4" style={styles.page} wrap={false}>
      <View>
        <ReportCoverBackground />
      </View>
      {companyLogo && (
        <View style={styles.logo}>
          <Image src={companyLogo} style={{ width: 100, height: 100 }} />
        </View>
      )}
      <View style={styles.coverContent}>
        <Text style={styles.reportName}>{t('report') + ' ' + (reportNameAddtion ? reportNameAddtion : '')}</Text>
        <Text style={styles.reportSubName}>{reportName}</Text>
        <View style={styles.divider} />
        <Text style={styles.reportDate}>{currentDate}</Text>
      </View>

      <View style={i18n.language === 'ar' ? [styles.footer, { flexDirection: 'row-reverse' }] : styles.footer}>
        <View
          style={
            i18n.language === 'ar'
              ? [styles.poweredBySection, { flexDirection: 'row-reverse' }]
              : styles.poweredBySection
          }
        >
          <Text style={styles.poweredByText}>{t('poweredBy')}</Text>
          <RasmalReportFooterLogo />
        </View>
        <View>
          <Text style={styles.website}>www.rasmal.io</Text>
        </View>
      </View>
    </Page>
  );
};

export default ReportCoverPage;
